export enum ValidationLimits {
  AGE_MIN = 0,
  AGE_MAX = 100,

  WEIGHT_MIN = 70,
  WEIGHT_MAX = 400,

  UPPER_ARM_MIN = 5,
  UPPER_ARM_MAX = 30,

  WAIST_MIN = 18,
  WAIST_MAX = 60,

  WRIST_MIN = 5,
  WRIST_MAX = 15,

  FASTING_BLOOD_SUGAR_MIN = 50,
  FASTING_BLOOD_SUGAR_MAX = 300,

  A1C_MIN = 3.0,
  A1C_MAX = 20.0,

  AHI_MIN = 0,
  AHI_MAX = 100
}

export enum DynamicFieldNames {
  UPPER_ARM_CIRCUMFERENCE = 'Upper Arm Circumference (inches)',
  WAIST_CIRCUMFERENCE = 'Waist Circumference (inches)',
  WRIST_CIRCUMFERENCE = 'Wrist Circumference (inches)',
  FASTING_BLOOD_SUGAR = 'Fasting Blood Sugar',
  A1C_WITHIN_LAST_6_MONTHS = 'A1C within the last 6 months',
  AHI_SCORE_FROM_SLEEP_STUDY = 'AHI Score from Sleep Study'
}

export enum DefaultValues {
  USA = 'USA'
}
